import { Trans, useLingui } from '@lingui/react/macro'
import { AppLogo } from '@/features/header/app-logo'
import { Link as MultibrandLink } from '@vgw/multibrand-fe-link'
import { getBrandConfig } from '@/config/config'
import { createFileRoute, Link } from '@tanstack/react-router'
import { Content } from '@/layout/content'
import { Layout } from '@/layout/layout'
import { Footer } from '@/features/footer/footer'
import { getBrandAssetsConfig } from '@/config/assets-config'

export const Route = createFileRoute('/geo-block')({
  component: GeoBlock,
})

function GeoBlock() {
  const { t } = useLingui()
  const { name, helpCenterUrl } = getBrandConfig()
  const { geoblock } = getBrandAssetsConfig()

  return (
    <Layout>
      <Content backgroundVariant="branded">
        <div className="mx-auto flex max-w-lg flex-1 flex-col items-center justify-center gap-10 px-2 py-10 sm:px-4 lg:px-6">
          <div className="flex flex-col items-center">
            <MultibrandLink asChild>
              <Link
                to="/"
                title={t`Go to VGW ${name} Homepage`}
                aria-label={t`Go to VGW ${name} Homepage`}
              >
                <AppLogo />
              </Link>
            </MultibrandLink>
          </div>
          <div className="flex grow flex-col items-center gap-4">
            <img srcSet={geoblock} className="size-37" alt="" aria-hidden />
            <div className="flex flex-col gap-3 text-center text-content">
              <h1 className="font-family-display text-2xl leading-9 font-bold tracking-normal">
                <Trans>Thank you for your interest!</Trans>
              </h1>
              <p className="font-family-body text-lg leading-7 font-light tracking-normal">
                <Trans>
                  Unfortunately, {name} is not available in your region.
                  <br />
                  If you believe you should have access, please visit{' '}
                  <MultibrandLink
                    className="underline"
                    size="lg"
                    href={helpCenterUrl}
                  >
                    Help Center
                  </MultibrandLink>
                  .
                </Trans>
              </p>
            </div>
          </div>
        </div>
      </Content>
      <Footer suppressAmoe />
    </Layout>
  )
}
